import API, { AuthorizeInterceptor } from 'cx-api-client-lite';

import Crapi from 'app/api/services/Crapi';
import DeltaConfig from 'app/api/services/DeltaConfig';
import Transifex from 'app/api/services/Transifex';
import Auth from 'app/api/services/Auth';
import Content from 'app/api/services/Content';
import News from 'app/api/services/News';
import LocaleInterceptor from 'app/api/interceptors/LocaleInterceptor';
import Subscription from 'app/api/services/Subscription';

const {
  crapiApiUrl,
  deltaConfigApiUrl,
  transifexUrl,
  cxApiParams,
  newsServiceUrl,
} = window.etp.config;

API.Crapi = Crapi;
API.Crapi.updateConfig({ env: process.env.SPA_ENV, baseURL: crapiApiUrl });

API.DeltaConfig = DeltaConfig;
API.DeltaConfig.updateConfig({ baseURL: deltaConfigApiUrl });

API.Transifex = Transifex;
API.Transifex.updateConfig({ baseURL: transifexUrl });

API.Auth = Auth;
API.Auth.updateConfig({ baseURL: cxApiParams.host });

API.Content = Content;
API.Content.updateConfig({ baseURL: cxApiParams.host });

API.News = News;
API.News.updateConfig({ baseURL: newsServiceUrl });

API.Subscription = Subscription;
API.Subscription.updateConfig({ baseURL: cxApiParams.host });

API.Content.addRequestInterceptor(AuthorizeInterceptor.getInterceptor());
API.DeltaConfig.addRequestInterceptor(AuthorizeInterceptor.getInterceptor());
API.Content.addRequestInterceptor(LocaleInterceptor.getInterceptor());
API.News.addRequestInterceptor(AuthorizeInterceptor.getInterceptor());
API.Subscription.addRequestInterceptor(AuthorizeInterceptor.getInterceptor());

export default API;
